module.exports = __webpack_public_path__ + "img/introduce-left.326b925f.png";